import React, { useState, useEffect, useRef } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './NoiseOnTheWaySlider.scss';
import leftArrow from '../../../../assets/smartxonnect/left.webp';
import rightArrow from '../../../../assets/smartxonnect/right.webp';
import whiteLeftArrow from '../../../../assets/smartxonnect/white-left-arrow.webp';
import whiteRightArrow from '../../../../assets/smartxonnect/white-left-arrow.webp';
import VehicleOverspeed from '../../../../assets/noise/vehicle-overspeed-alert.webp';
import Geofencing from '../../../../assets/noise/geofencing.webp';
import VehicleCrashAlert from '../../../../assets/noise/vehicle-crash-alert.webp';
import callandsms from '../../../../assets/noise/call-and-sms01.webp';
import CarbonSaved from '../../../../assets/noise/remote-control02.webp';
import IconPlus from '../../../../assets/noise/downarrow.png';
import IconMinus from '../../../../assets/noise/downarrow.png';
// const PrevArrow = (props) => {
//   const { className, onClick, isDisabled } = props;

//   const handlePrevClick = () => {
//     if (!isDisabled) {
//       dataLayer.push({
//         event: 'always_connected_banner_navigation',
//         action: 'previous_arrow_clicked',
//         BrandName: 'TVS iQube',
//         VariantName: 'SmartXonnect',
//       });
//       onClick();
//     }
//   };

//   return (
//     <div className={`${className} custom-prev-arrow`} onClick={handlePrevClick}>
//       <img src={isDisabled ? whiteLeftArrow : leftArrow} alt="Previous" loading="lazy" />
//     </div>
//   );
// };

// const NextArrow = (props) => {
//   const { className, onClick, isDisabled } = props;

//   const handleNextClick = () => {
//     if (!isDisabled) {
//       dataLayer.push({
//         event: 'always_connected_banner_navigation',
//         action: 'next_arrow_clicked',
//         BrandName: 'TVS iQube',
//         VariantName: 'SmartXonnect',
//       });
//       onClick();
//     }
//   };

//   return (
//     <div className={`${className} custom-next-arrow`} onClick={handleNextClick}>
//       <img
//         src={isDisabled ? whiteLeftArrow : rightArrow}
//         alt="Next"
//         className={isDisabled ? 'disabled' : 'rotate-180'}
//         loading="lazy"
//       />
//     </div>
//   );
// };
const AccordionItem = ({ item, isOpen, onToggle }) => {
  return (
    <div className={`noiseaccordion-item ${isOpen ? 'open' : ''}`}>
      <div className="noiseaccordion-header gotham-medium" onClick={onToggle}>
        <h3 className="gotham-medium">{item.title}</h3>
        <img
          src={isOpen ? IconMinus : IconPlus}
          alt={isOpen ? 'Collapse' : 'Expand'}
          className="accordion-toggle-icon"
        />
      </div>
      {isOpen && (
        <div className="noiseaccordion-body gotham-medium">
          <div className="noiseaccordion-image">
            <img src={item.image} alt={item.title} loading="lazy" />
          </div>
          <p className="gotham-medium">{item.description}</p>
        </div>
      )}
    </div>
  );
};
const NoiseOnTheWaySlider = (props) => {
  const sliderRef = useRef(null);
  const [isMobile, setIsMobile] = useState(false);
  const [openIndex, setOpenIndex] = useState(0);

  const handleResize = () => {
    setIsMobile(window.innerWidth <= 768);
  };

  useEffect(() => {
    handleResize(); // Initial check
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const data = [
    {
      title: 'Vehicle Overspeed Alert',
      description: 'Get notified on your watch the moment your scooter crosses speed limits.',
      image: VehicleOverspeed,
    },
    {
      title: 'Vehicle Geofence Alert',
      description: 'Stay updated with instant alerts if your scooter crosses geofence limits',
      image: Geofencing,
    },
    {
      title: 'Vehicle Crash or Fall Alert',
      description: 'Stay informed the moment your vehicle detects a crash or fall.',
      image: VehicleCrashAlert,
    },
    {
      title: 'Remote Music Control',
      description: 'Play, pause and skip tracks instantly without reaching for your phone',
      image: CarbonSaved,
    },
    {
      title: 'Call & SMS Quick reply',
      description: 'Send instant replies to calls and texts directly from your smartwatch',
      image: callandsms,
    },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
  };
  return (
    <div
      className="noise-always-connected-slider-wrapper ontheway commonContainer"
      data-aos="fade-up"
      ref={sliderRef}
    >
      <div className="header-section">
        <h2 className="before-ride-header gotham-medium">{props?.fields?.Heading?.value}</h2>
        <h4 className="subtitle gotham-medium">{props?.fields?.Title?.value}</h4>
      </div>
      <div className="slider-section">
        {isMobile ? (
          <div className="accordion-mobile-view">
            {data.map((item, index) => (
              <AccordionItem
                key={index}
                item={item}
                isOpen={openIndex === index}
                onToggle={() => setOpenIndex(openIndex === index ? null : index)}
              />
            ))}
          </div>
        ) : (
          <Slider {...settings}>
            {data.map((item, index) => (
              <div key={index} className="always-connected-slider-card">
                <div className="always-connected-slider-image">
                  <img src={item.image} alt={item.title} loading="lazy" />
                </div>
                <div className="always-connected-slider-content">
                  <h2 className="gotham-medium always-connected-title">{item.title}</h2>
                  <p className="gotham-medium always-connected-subtitle">{item.description}</p>
                </div>
              </div>
            ))}
          </Slider>
        )}
      </div>
    </div>
  );
};

export default React.memo(NoiseOnTheWaySlider);
